firebird.factory('annotationService', [
    '$rootScope',
    '$window',
    '$interval',
    '$timeout',
    '$q',
    'vertoService',
    'socketService',
    'logService',
    'helperService',
    'contentService',
    'analyticsWrapperService',
    'canvasMonitoringService',
    'annotationConnection',
    'attendeeService',
    'attendeeListService',
    'notificationService',
    'storageService',
    'screenShareService',
    'localizationService',
    'vdiService',
    'executionEnvironmentEnum',
    function (
        $rootScope,
        $window,
        $interval,
        $timeout,
        $q,
        vertoService,
        socketService,
        logService,
        helperService,
        contentService,
        analyticsWrapperService,
        canvasMonitoringService,
        annotationConnection,
        attendeeService,
        attendeeListService,
        notificationService,
        storageService,
        screenShareService,
        localizationService,
        vdiService,
        executionEnvironmentEnum
    ) {
        const logger = new LogServiceWrapper(logService, 'annotationService');

        var peerConnection = null;
        var iceServers;
        var drawingCollector;
        var annotator;
        // temporal solution to make soft transfer to new meeting-state event payload
        var meetingStateV2EventHandled = false;

        var inActiveConnection = false;

        var canHostAnnotation = false;
        var isInitiator = false;
        var paperJSInitalized = false;
        var controllerName = '';
        var sharedScreenData = null;
        var listenersAttached = false;

        var annotationEnabled = true;
        var annotationSuspended = false;
        var annotationOccured = false;
        var isDraggingEnableButton = false;

        var exchangeToken = null;
        var receiverExchangeToken = null;

        var sharerConnection; // used for the connection to the person doing screen share
        // populated on the viewers side

        var viewerConnections = {}; //used for holding the connections to the people performing annotation
        //populated on the screen sharer side

        var colors = ['#FA373B', '#FFD22E', '#74B800', '#00A4FF', '#807DD8', '#000000'];

        var localAnnotationEnabled = false;
        var sharerSupportsAnnotation = false;
        var requestTimeOutTimer = null;
        var basicAeroTheme = false;
        var presenterCanAnnotate = true;
        var isSharingAppScreen = false;

        var bordersOverlay = { leftRight: 0, topBottom: 0 };

        var restartAnnotationAfterSocketReconnect = false;

        var service = {
            connectivityStateType: {
                connecting: 1,
                connected: 2,
                reconnecting: 3,
                disconnected: 4,
                unrequestedDisconnect: 5
            },
            init: init,
            getFeatureCode: getFeatureCode,
            startAnnotation: startAnnotation,
            dataChannelSend: dataChannelSend,
            attachListeners: attachListeners,
            removeListeners: removeListeners,
            getIsInSession: getIsInSession,
            setIsInSession: setIsInSession,
            getIsController: getIsController,
            stopAnnotation: stopAnnotation,
            setSharedScreenId: setSharedScreenId,
            getIsInitiator: getIsInitiator,
            setIsInitiator: setIsInitiator,
            getIsAnnotationEnabled: getIsAnnotationEnabled,
            setIsAnnotationEnabled: setIsAnnotationEnabled,
            getPresenterCanAnnotate: getPresenterCanAnnotate,
            getViewerConnections: getViewerConnections,
            getSharerConnection: getSharerConnection,
            suspendAnnotation: suspendAnnotation,
            continueAnnotation: continueAnnotation,
            getIsSuspended: getIsSuspended,
            setIsSuspended: setIsSuspended,
            destroyDrawingCanvasForAnnotation: destroyDrawingCanvasForAnnotation,
            attachAnnotationListeners: attachAnnotationListeners,
            initPresenterAnalyticsListeners: initPresenterAnalyticsListeners,
            _getIsPaperJSInitalized: getIsPaperJSInitalized,
            _setIsListenersAttached: setIsListenersAttached,
            createAnnotationWindow: createAnnotationWindow,
            setCanHostAnnotation: setCanHostAnnotation,
            getCanHostAnnotation: getCanHostAnnotation,
            initRootscopeListeners: initRootscopeListeners,
            reconnect: reconnect,
            getPenColor: getPenColor,
            initColorPalette: initColorPalette,
            requestConnection: requestConnection,
            sendUpdatedColor: sendUpdatedColor,
            resetButtonLocation: resetButtonLocation,
            recalculatePenButtonPosition: recalculatePenButtonPosition,
            onColorChange: onColorChange,
            clearCanvas: clearCanvas,
            setIsLocalAnnotationEnabled: setIsLocalAnnotationEnabled,
            getIsLocalAnnotationEnabled: getIsLocalAnnotationEnabled,
            disconnect: disconnect,
            setSharerSupportsAnnotation: setSharerSupportsAnnotation,
            getSharerSupportsAnnotation: getSharerSupportsAnnotation,
            getConnectivitystate: getConnectivitystate,
            setHasBasicAeroTheme: setHasBasicAeroTheme,
            getHasBasicAeroTheme: getHasBasicAeroTheme,
            getColors: getColors,
            saveColorSelection: saveColorSelection,
            getColorSelection: getColorSelection,
            setPaperViewSize: setPaperViewSize,
            getIsActive: getIsActive,
            attachCanvasAndBorderMaskElement: attachCanvasAndBorderMaskElement,
            isPenDragEnabled: isPenDragEnabled,
            clearScreen: clearScreen,
            setAnnotationPenDraggable: setAnnotationPenDraggable,
            hideAnnotationTooltip: hideAnnotationTooltip,
            isScreenShareFeedPlaying: isScreenShareFeedPlaying,
            showAnnotationButtonOnTopVDI: showAnnotationButtonOnTopVDI,
            cleanupAnnotationUiForVDI: cleanupAnnotationUiForVDI,
            formatIceServersForVDI: formatIceServersForVDI,
            prepareIceServers: prepareIceServers,
            getShouldRestartAnnotationAfterSocketReconnect: getShouldRestartAnnotationAfterSocketReconnect,
            setShouldRestartAnnotationAfterSocketReconnect: setShouldRestartAnnotationAfterSocketReconnect,
            attachAnnotationListenersOnCitrix: attachAnnotationListenersOnCitrix,
            handleMouseEnterEventOnCanvas: handleMouseEnterEventOnCanvas,
            setCitrixCursorColor: setCitrixCursorColor
        };

        var isScreenShareFeedPlayed = false;
        var annotationButtonBounds = null;
        var annotationButtonTooltipBounds = null;
        var tooltipListenerAttachedForVDI = false;
        var currentConnectivityState = service.connectivityStateType.disconnected;
        var annotatorColor = service.getColorSelection();

        var cursorStyle = document.createElement('style');
        var citrixCursorStyle = document.createElement('style');
        citrixCursorStyle.setAttribute('id', 'citrix-cursor-style');
        document.head.appendChild(cursorStyle);
        setCursorColor(annotatorColor);

        init();

        return service;

        ////////////////////////

        function setPaperViewSize() {
            if ($window.paper.view && attendeeService.getIsSfuEnabled()) {
                bordersOverlay = screenShareService.getBordersOverlay('.remote.screen.primary > video');
                var video = $window.$('.remote.screen.primary > video');
                var canvas = $window.$('#annotation-canvas');
                if (!helperService.getVDIRef().showContentsOnTopOfVideo) {
                    var videoContainer = window.$('.remote.screen > video').get(0).getBoundingClientRect();
                    canvas.get(0).style.width = videoContainer.width + 'px';
                    canvas.get(0).style.height = videoContainer.height + 'px';
                } else {
                    canvas.css('top', bordersOverlay.topBottom + 'px');
                    canvas.css('bottom', bordersOverlay.topBottom + 'px');
                    canvas.css('left', bordersOverlay.leftRight + 'px');
                    canvas.css('right', bordersOverlay.leftRight + 'px');
                    canvas.css('width', video.innerWidth() - 2 * bordersOverlay.leftRight);
                    canvas.css('height', video.innerHeight() - 2 * bordersOverlay.topBottom);
                }

                $window.paper.view.setViewSize(
                    video.innerWidth() - 2 * bordersOverlay.leftRight,
                    video.innerHeight() - 2 * bordersOverlay.topBottom
                );
            }
        }

        function getHasBasicAeroTheme() {
            return basicAeroTheme;
        }

        function setHasBasicAeroTheme(basicAero) {
            basicAeroTheme = basicAero;
        }

        function getConnectivitystate() {
            return currentConnectivityState;
        }

        function setSharerSupportsAnnotation(supportsAnnotation) {
            sharerSupportsAnnotation = supportsAnnotation;
        }

        function getSharerSupportsAnnotation() {
            return sharerSupportsAnnotation;
        }

        function getPenColor() {
            return annotatorColor;
        }

        function clearScreen() {
            var data = {
                left: 0,
                top: 0,
                width: 0,
                height: 0,
                mouseEvent: true,
                mouseUp: true
            };
            service.dataChannelSend(data);

            if (annotator) {
                annotator.closePath();
            }
        }

        function initRootscopeListeners() {
            $rootScope.$on('sa-suspend', onSuspend);
            $rootScope.$on('sa-continue', onContinue);
            $rootScope.$on('sa-request-connection', onRequestedConnection);

            $rootScope.$on('sa-offer-created', onRemoteOffer);
            $rootScope.$on('sa-answer-created', onRemoteAnswer);
            $rootScope.$on('sa-new-ice-candidate', onNewRemoteIceCandidate);
            $rootScope.$on('electron-screen-selected', onElectronScreenSelected);
            $rootScope.$on('electron-screen-preview', onElectronScreenPreview);
            $rootScope.$on('start-screenshare', onStartScreenShare);
            $rootScope.$on('electron-screen-preview-clear', onElectronScreenPreviewClear);
            $rootScope.$on('electron-screen-preview-destroy', onElectronScreenPreviewDestroy);
            $rootScope.$on('content-cleanup', onContentCleanup);
            $rootScope.$on('content-stopped', onContentStopped);

            $rootScope.$on('hd-screenshare-conf-call-connected', onHDScreenShareConfCallConnected);
            $rootScope.$on('node-reconnected', onNodeReconnected);
            $rootScope.$on('node-disconnected', onNodeDisconnected);
            $rootScope.$on('sa-sharer-supports-annotation', onSharerSupportsAnnotation);
            $rootScope.$on('meeting-state-v2', onMeetingStateV2Updated);
        }

        //in place for likely providing unite functionality
        function getFeatureCode() {
            return 'annotation';
        }

        function getIsInSession() {
            return inActiveConnection;
        }

        function setIsInSession(inSession) {
            inActiveConnection = inSession;
            $rootScope.$broadcast('annotation-in-session', inSession && !service.getIsSuspended());
        }

        function setCanHostAnnotation(canHost) {
            canHostAnnotation = canHost;
        }

        function getCanHostAnnotation() {
            if (helperService.isUniteApplication()) {
                return helperService.isUniteSupportFeature(getFeatureCode());
            }

            return helperService.isElectron() && !!canHostAnnotation;
        }

        function setIsAnnotationEnabled(flag) {
            logService.log('Setting Annotation Enabled State', flag);
            annotationEnabled = flag;
        }

        function setIsListenersAttached(attached) {
            listenersAttached = attached;
        }

        function getIsAnnotationEnabled() {
            return true;
        }

        function getIsInitiator() {
            return isInitiator;
        }

        function setIsInitiator(initiator) {
            isInitiator = initiator;
        }

        function getIsController() {
            return !isInitiator;
        }

        function getIsPaperJSInitalized() {
            return paperJSInitalized;
        }

        function attachAnnotationListeners() {
            if (!service._getIsPaperJSInitalized()) {
                var canvas = $window.document.getElementById('annotation-canvas');
                if (!canvas) {
                    logger.error('attachAnnotationListeners', 'canvas element not found for annotation');
                    return;
                }
                $window.$('#annotation-canvas').on('remove', function () {
                    //when sfu video feed gets removed from dom, so does the annotation canvas
                    //therefore paper.js will need to be reinitialized on the new canvas
                    paperJSInitalized = false;
                    if (service.getIsInSession()) {
                        $rootScope.$broadcast('annotation-connection-failed');
                    }
                    logger.log(
                        'attachAnnotationListeners',
                        'annotation disconnected; reason: sfu video feed removed from dom'
                    );
                    service.disconnect();
                    service.removeListeners();
                });
                $window.paper.setup(canvas);
                paperJSInitalized = true;
            }

            if (attendeeService.getIsSfuEnabled()) {
                service.setPaperViewSize();
                service.attachListeners();
                onHDScreenShareConfCallConnected();
                //compatibility with zoom in code to reset zoom when annotation comes on
                $window.$('.remote.screen.primary')[0].dispatchEvent(new Event('mousedown'));
                $window.$('body')[0].dispatchEvent(new Event('mouseup'));
                $window.$('.remote.screen.primary').on('transitionend', function () {
                    resizeCanvas();
                });
                $window.$('.remote.screen.primary').on('resize', function () {
                    resizeCanvas();
                });
            } else {
                service.attachListeners();
            }

            if (helperService.getVDIRef().getVdiType() === executionEnvironmentEnum.Citrix) {
                service.attachAnnotationListenersOnCitrix();
            }
            service.initColorPalette();
        }

        function resizeCanvas() {
            service.clearCanvas();
            service.setPaperViewSize();
        }

        function recalculatePenButtonPosition() {
            var finishedDraggingElement = $window.$('.annotation-enabler-button');
            var width = 0,
                height = 0;

            if (helperService.getIsRedesign()) {
                width = $window.$('#background').width();
                height = $window.$('#background').height();
            } else if (attendeeService.getIsSfuEnabled()) {
                width = $window.$('#videoroom-videos').width();
                height = $window.$('#videoroom-videos').height();
            } else {
                width = $window.$('#conference').width();
                height = $window.$('#conference').height();
            }

            if (finishedDraggingElement) {
                if (finishedDraggingElement.position().left < 20) {
                    finishedDraggingElement.css('left', 20);
                } else if (finishedDraggingElement.position().left > width - 90) {
                    finishedDraggingElement.css('left', width - 90);
                }

                if (finishedDraggingElement.position().top < 20) {
                    finishedDraggingElement.css('top', 20);
                } else if (finishedDraggingElement.position().top > height - 90) {
                    finishedDraggingElement.css('top', height - 90);
                }
            }
        }

        function resetButtonLocation() {
            $window.$('.annotation-enabler-button').css('left', '');
            $window.$('.annotation-enabler-button').css('top', '');
        }

        function initPresenterAnalyticsListeners() {
            $window.preloadedApi.remote.ipcRenderer.onPresenterToggleAnnotation(function (ev, data) {
                analyticsWrapperService.eventTrack(
                    'Meeting - Annotation - Presenter turns ' + (data ? 'on' : 'off') + ' annotation',
                    {
                        category: 'Annotation',
                        attendee: attendeeService.getEmail()
                    }
                );
            });

            $window.preloadedApi.remote.ipcRenderer.onPresenterToggleColor(function (ev, data) {
                analyticsWrapperService.eventTrack('Meeting - Annotation - Presenter selects different color', {
                    category: 'Annotation',
                    attendee: attendeeService.getEmail()
                });
            });

            $window.preloadedApi.remote.ipcRenderer.onPresenterStartedAnnotating(function (ev, data) {
                analyticsWrapperService.eventTrack('Meeting - Annotation - Presenter started annotating', {
                    category: 'Annotation',
                    attendee: attendeeService.getEmail()
                });
            });
        }

        function initColorPalette() {
            $window.$('#annotation-color-picker input[type=radio]').each((index, radio) => {
                if (radio.value === getColorSelection()) {
                    radio.checked = true;
                }
                radio.addEventListener('change', () => service.onColorChange(radio.value));
            });
            $window.angular.element($window).bind('resize', function () {
                service.resetButtonLocation();
                service.clearCanvas();
            });
        }

        function onColorChange(color) {
            annotatorColor = color;
            annotator.updatePenColor(annotatorColor);
            $rootScope.$broadcast('annotation-color-changed', annotatorColor);
            service.sendUpdatedColor();
            service.saveColorSelection(annotatorColor);
            analyticsWrapperService.eventTrack('Meeting - Annotation - User selects different color', {
                category: 'Annotation',
                attendee: attendeeService.getEmail()
            });

            setCursorColor(color);
            if (helperService.getVDIRef().getVdiType() === executionEnvironmentEnum.Citrix) {
                service.setCitrixCursorColor(color);
            }
        }

        function saveColorSelection(color) {
            storageService.set('annotationPenColor', color);
        }

        function getColorSelection() {
            var existingColor = storageService.get('annotationPenColor');
            if (existingColor) {
                return existingColor;
            }
            let newColor = colors[Math.floor(Math.random() * colors.length)];
            service.saveColorSelection(newColor);
            return newColor;
        }

        function getColors() {
            return colors;
        }

        function sendUpdatedColor() {
            var data = { updatedColor: annotatorColor };
            service.dataChannelSend(data);
        }

        function setSharedScreenId(data) {
            sharedScreenData = data;
        }

        //Here for testing, should not be asked for in normal flow
        function getSharerConnection() {
            return sharerConnection;
        }

        //Here for testing, should not be asked for in normal flow
        function getViewerConnections() {
            return viewerConnections;
        }

        function onElectronScreenSelected(e, data) {
            logger.log('onElectronScreenSelected', 'Electron screen selected, screen id:', data.id);
            logger.log('onElectronScreenSelected', 'Electron screen selected, display id:', data.displayId);
            isSharingAppScreen = data.id && data.id.indexOf('screen') != 0;
            setSharedScreenId(data);
            if (isSharingAppScreen) {
                service.suspendAnnotation();
            }
        }

        function onStartScreenShare(e, data) {
            if (helperService.isElectron()) {
                $window.preloadedApi.remote.ipcRenderer.sendScreenPreviewCreate();
            }
        }

        function onElectronScreenPreview(e, screenInfo) {
            if (helperService.isElectron()) {
                $window.preloadedApi.remote.ipcRenderer.sendScreenPreview(screenInfo);
            }
        }

        function onElectronScreenPreviewClear(e, data) {
            if (helperService.isElectron()) {
                $window.preloadedApi.remote.ipcRenderer.sendScreenPreviewClear();
            }
        }

        function onElectronScreenPreviewDestroy(e, data) {
            if (helperService.isElectron()) {
                $window.preloadedApi.remote.ipcRenderer.sendScreenPreviewDestroy();
            }
        }

        function onContentCleanup() {
            logger.log('onContentCleanup', 'Annotation service received content cleanup event');
            if (service.getIsInitiator()) {
                service.stopAnnotation();
            }
            isScreenShareFeedPlayed = false;
        }

        function onContentStopped(e, data) {
            logger.log('onContentStopped', 'Annotation service received content stopped event');
            if (service.getIsInitiator()) {
                service.stopAnnotation();
            } else {
                paperJSInitalized = false;
                if (!helperService.getVDIRef().showContentsOnTopOfVideo) {
                    service.cleanupAnnotationUiForVDI();
                }
            }
            isScreenShareFeedPlayed = false;
        }

        function onNodeDisconnected(e, data) {
            logger.log('onNodeDisconnected', 'Annotation service received node disconnected event');
            sendDirectDisconnectEvent();
            if (service.getIsInitiator()) {
                service.setShouldRestartAnnotationAfterSocketReconnect(true);
                service.stopAnnotation();
            }
            isScreenShareFeedPlayed = false;
        }

        function onNodeReconnected() {
            logger.log(
                'onNodeReconnected',
                'Restart annotation: ',
                service.getShouldRestartAnnotationAfterSocketReconnect()
            );
            if (service.getShouldRestartAnnotationAfterSocketReconnect()) {
                service
                    .createAnnotationWindow()
                    .then(function () {
                        service.setIsInitiator(true);
                    })
                    .catch(function (err) {
                        logger.error(
                            'onNodeReconnected',
                            'Unable to restart annotation after socket reconnection',
                            err
                        );
                    });
                service.setShouldRestartAnnotationAfterSocketReconnect(false);
            }
        }

        //This function is not really called anymore, but it's in here for testing purposes plus testing in the client as the underlying
        // property is still used in event calls within the client
        function getPresenterCanAnnotate() {
            return presenterCanAnnotate;
        }

        function onSharerSupportsAnnotation(e, data) {
            logService.log('Annotation service received sharer supports annotation event');
            service.setSharerSupportsAnnotation(data.sharerSupportsAnnotation);
            if (data.screenShareType && typeof data.screenShareType === 'string') {
                var type = data.screenShareType.split('-');
                try {
                    contentService.setScreenShareType(type[0]);
                    contentService.setScreenShareHostType(type[1]);
                } catch (err) {
                    logger.error(
                        'onSharerSupportsAnnotation',
                        'error during parsing param to get type and platform',
                        err
                    );
                }
            }
        }

        function onSuspend() {
            service.setIsSuspended(true);
            if (!service.getIsInitiator()) {
                service.removeListeners();
                logger.log('onSuspend', 'annotation disconnected; reason: sharer suspended annotation');
                service.disconnect();
            } else {
                var viewerConnections = service.getViewerConnections();
                for (var id in viewerConnections) {
                    var connection = viewerConnections[id];
                    connection.close();
                    delete viewerConnections[id];
                }
            }
        }

        function onContinue() {
            service.setIsSuspended(false);

            if (attendeeService.getIsSfuEnabled()) {
                if (!service.getIsInitiator()) {
                    if (localAnnotationEnabled) {
                        service.requestConnection();
                    }
                }
                return;
            }

            var hdScreenShareCall = vertoService.getHDScreenShareCall();
            if (
                hdScreenShareCall &&
                hdScreenShareCall.rtc &&
                hdScreenShareCall.rtc.remoteStream.getVideoTracks()[0].enabled
            ) {
                if (!service.getIsInitiator()) {
                    //make sure there is a valid connection
                    if (localAnnotationEnabled) {
                        service.requestConnection();
                    }
                }
            }
        }

        function setIsLocalAnnotationEnabled(enabled) {
            localAnnotationEnabled = enabled;
        }

        function getIsLocalAnnotationEnabled() {
            return localAnnotationEnabled;
        }

        function attachCanvasAndBorderMaskElement(div) {
            $window.$(div).append('<canvas id="annotation-canvas"></canvas>');
        }

        function requestConnection() {
            if (!service.getSharerSupportsAnnotation()) {
                return;
            }

            currentConnectivityState = service.connectivityStateType.connecting;
            socketService.send({
                message: 'sa-request-connection'
            });
            if (!requestTimeOutTimer) {
                requestTimeOutTimer = $timeout(
                    function () {
                        currentConnectivityState = service.connectivityStateType.disconnected;
                        $rootScope.$broadcast('annotation-connection-failed');
                        service.disconnect();
                        service.removeListeners();
                        notificationService.show(
                            localizationService.translate('SCREENSHARE.NOTIFICATIONS.STARTING_ANNOTATION_SOME_ISSUE'),
                            'warning'
                        );
                        logger.warn(
                            'requestConnection',
                            'annotation disconnected; reason: connection request timed out'
                        );
                        requestTimeOutTimer = null;
                    },
                    helperService.getVDIRef().getVdiType() === executionEnvironmentEnum.Citrix ? 10000 : 5000
                );
            }
        }

        function disconnect() {
            if (sharerConnection) {
                sharerConnection.close();
                sharerConnection = null;
            }
            service.setIsInSession(false);
            currentConnectivityState = service.connectivityStateType.disconnected;
        }

        function onRequestedConnection(e, data) {
            if (isInitiator) {
                var attendantId = data.attendantId;
                var attendee = attendeeListService.findAttendee(attendantId);
                if (attendee && !service.getIsSuspended()) {
                    //check for existing connection and closing/removing it
                    //since client is requesting new connection
                    if (viewerConnections[attendantId]) {
                        viewerConnections[attendantId].close();
                        delete viewerConnections[attendantId];
                    }
                    service.startAnnotation([attendee]);
                }
            }
        }

        function init() {
            if (!helperService.isMobile()) {
                service.initRootscopeListeners();
            }

            if (!helperService.isElectron()) {
                logService.log('No electron ipcRenderer detected.  not initializing ipcRenderer in annotationService');
                //return;
            } else {
                logService.log('Initializing annotation service ... ');
                service.initPresenterAnalyticsListeners();

                //ipcRenderer.on('sa-controller-close', function(){});
            }

            if (!helperService.browserHasWebRTC()) {
                logService.log('no webrtc.  returning.');
                return;
            }
        }

        function createAnnotationWindow() {
            var deferred = $q.defer();
            var timeoutCB = $timeout(function () {
                logger.error('createAnnotationWindow', 'time out creating annotation window');
                deferred.reject();
            }, 10000);

            if (helperService.isElectron()) {
                sharedScreenData.attendantId = attendeeService.getAttendantId();
                sharedScreenData.attendantName = attendeeService.getScreenName();
                sharedScreenData.presenterCanAnnotate = presenterCanAnnotate;
                sharedScreenData.isSharingAppScreen = isSharingAppScreen;
                $window.preloadedApi.remote.ipcRenderer.sendSharedScreenId(sharedScreenData);
            }

            $window.preloadedApi.remote.ipcRenderer.onAnnotationWindowCreated(function () {
                deferred.resolve();
                $timeout.cancel(timeoutCB);
            });

            $window.preloadedApi.remote.ipcRenderer.onWindowDisplayChanged(function () {
                var data = { windowDisplayChanged: true };
                var viewerConnections = service.getViewerConnections();
                for (var id in viewerConnections) {
                    var connection = viewerConnections[id];
                    connection.sendDataChannelMessage(data);
                }
            });

            return deferred.promise;
        }

        function startAnnotation(targetList) {
            isInitiator = true;

            for (var i = 0; i < targetList.length; i++) {
                var opts = {
                    viewerAttendantId: targetList[i].attendantId,
                    viewerName: targetList[i].screenName,
                    iceServers: service.prepareIceServers(helperService.getVDIRef().getVdiType()),
                    callbacks: {
                        dataChannelMessage: dataChannelMessageCallback,
                        ready: readyCallback,
                        processOffer: processOfferCallback,
                        processAnswer: processAnswerCallback,
                        processICECandidate: processICECandidateCallback,
                        dataChannelClose: dataChannelCloseCallback,
                        disconnected: disconnectCallback
                    }
                };

                var connection = new annotationConnection(opts);

                viewerConnections[opts.viewerAttendantId] = connection;

                connection.connectCreateOffer();
            }
            inActiveConnection = true;
        }

        function getIsSuspended() {
            return annotationSuspended;
        }

        function setIsSuspended(suspended) {
            annotationSuspended = suspended;
            $rootScope.$broadcast('annotation-in-session', !suspended);
            digest();
        }

        function suspendAnnotation() {
            socketService.send({
                message: 'sa-suspend'
            });
            //should clear out whatever drawing that is on screen
            if (helperService.isElectron()) {
                $window.preloadedApi.remote.ipcRenderer.sendClearAnnotationScreen();
            }
        }

        function continueAnnotation() {
            socketService.send({
                message: 'sa-continue'
            });
        }

        function processOfferCallback(offer, viewerAttendantId) {
            logService.log('processOfferCallback ...', viewerAttendantId);
            var wrapper = { offer: offer };
            wrapper.initiatorAttendantId = attendeeService.getAttendantId();
            wrapper.viewerAttendantId = viewerAttendantId;
            wrapper.exchangeToken = exchangeToken;

            socketService.send({
                message: 'sa-offer-created',
                data: wrapper
            });
        }

        function processICECandidateCallback(ev, toAttendantId) {
            logService.log('processICECandidateCallback ...', ev, toAttendantId);
            var wrapper = { candidate: ev.candidate };
            wrapper.toAttendantId = toAttendantId;
            wrapper.fromAttendantId = attendeeService.getAttendantId();

            socketService.send({
                message: 'sa-new-ice-candidate',
                data: wrapper
            });
        }

        function processAnswerCallback(answer, initiatorAttendantId) {
            logService.log('processAnswerCallback ...', initiatorAttendantId);
            var wrapper = { answer: answer };
            wrapper.initiatorAttendantId = initiatorAttendantId;
            wrapper.viewerAttendantId = attendeeService.getAttendantId();
            wrapper.penColor = annotatorColor;

            socketService.send({
                message: 'sa-answer-created',
                data: wrapper
            });
        }

        function reconnect() {
            try {
                currentConnectivityState = service.connectivityStateType.reconnecting;
                service.requestConnection();
            } catch (error) {
                $timeout(function () {
                    service.reconnect();
                }, 1000);
            }
        }

        function disconnectCallback(data) {
            if (!isInitiator) {
                logService.log('annotator received disconnect event');
                service.removeListeners();
                if (service.getIsInSession()) {
                    //most likely an unintended disconnection
                    currentConnectivityState = service.connectivityStateType.unrequestedDisconnect;
                    service.reconnect();
                }
                sharerConnection.close();
                sharerConnection = null;
            } else {
                if (data && data.viewerId) {
                    if (viewerConnections[data.viewerId]) {
                        viewerConnections[data.viewerId].close();
                        delete viewerConnections[data.viewerId];
                        if (helperService.isElectron() && !annotationSuspended) {
                            $window.preloadedApi.remote.ipcRenderer.sendRemoveAnnotator(data);
                        }
                    }
                }
                logService.log('sharer received disconnect event');
            }
        }

        function readyCallback(data) {
            if (isInitiator) {
                logService.log('readyCallback sending sa-connect event', data);
                $window.preloadedApi.remote.ipcRenderer.sendAnnotatorConnect(data);
            } else {
                currentConnectivityState = service.connectivityStateType.connected;
                logService.log('readyCallback attaching listeners');
                if (requestTimeOutTimer) {
                    $timeout.cancel(requestTimeOutTimer);
                    requestTimeOutTimer = null;
                }
                service.setIsInSession(true);
                service.attachAnnotationListeners();
            }
        }

        function dataChannelMessageCallback(msg) {
            let msgData = msg.data;
            // VMware SDK internally encodes the data into ArrayBuffer before sending it over
            // the datachannel. Hence we need to decode it back to expected format upon receiving it.
            if (msgData?.byteLength) {
                msgData = new TextDecoder().decode(msgData);
            }
            if (msgData) {
                if (msgData.indexOf('"disconnect":') > 0) {
                    var data = JSON.parse(msgData);
                    logger.log(
                        'dataChannelMessageCallback',
                        'direct disconnect message received.  reason:',
                        data.reason
                    );
                    //TODO: add stop annotation callback here once it's adjusted
                    $window.preloadedApi.remote.ipcRenderer.sendAnnotatorDisconnect(data);
                    return;
                }

                if (msgData.indexOf('"updatedColor":') > 0) {
                    var colorObj = JSON.parse(msgData);
                    logger.log('dataChannelMessageCallback', 'update color message received.', colorObj);
                    $window.preloadedApi.remote.ipcRenderer.sendAnnotatorColorUpdated(colorObj);
                    return;
                }

                if (msgData.indexOf('"windowDisplayChanged":') > 0) {
                    logger.log('dataChannelMessageCallback', 'window display changed message received.');
                    // on receiving the 'windowDisplayChanged' message from the sharer, wait for 1 sec
                    // to update the canvas as the UI is still getting updated
                    setTimeout(function () {
                        resizeCanvas();
                    }, 1000);
                    return;
                }

                if (helperService.isElectron() && !annotationSuspended) {
                    $window.preloadedApi.remote.ipcRenderer.sendAnnotatorMapEvent(msgData);
                }
            }
        }

        function dataChannelCloseCallback() {
            logService.log('dataChannelCloseCallback ... ');
            if (!isInitiator) {
                if (service.getIsInSession()) {
                    $rootScope.$broadcast('annotation-connection-failed');
                }
                service.removeListeners();
                logger.warn('dataChannelCloseCallback', 'annotation disconnected; reason: datachannel closed');
                service.disconnect();
            }
            //TODO: Add stop annotation callback where once it's adjusted
        }

        function onNewRemoteIceCandidate(evt, data) {
            logService.log('starting onNewRemoteIceCandidate ...', data);
            if (isInitiator) {
                if (
                    viewerConnections[data.fromAttendantId] &&
                    viewerConnections[data.fromAttendantId].getViewerAttendantId() === data.fromAttendantId
                ) {
                    logService.log('found viewer connection ICE Candidate');
                    viewerConnections[data.fromAttendantId].connectICECandiate(data.candidate);
                }
            } else {
                sharerConnection.connectICECandiate(data.candidate);
            }
        }

        function onRemoteAnswer(evt, data) {
            logService.log('onRemoteAnswer ...', data);

            if (
                viewerConnections[data.viewerAttendantId] &&
                viewerConnections[data.viewerAttendantId].getViewerAttendantId() === data.viewerAttendantId
            ) {
                logService.log('found viewer connection for answer', data.answer);
                viewerConnections[data.viewerAttendantId].connectReceiveAnswer(data.answer);
                viewerConnections[data.viewerAttendantId].setPenColor(data.penColor);
            }
        }

        function onRemoteOffer(evt, data) {
            logService.log('onRemoteOffer ...', data.offer.sdp);

            var opts = {
                initiatorAttendantId: data.initiatorAttendantId,
                iceServers: service.prepareIceServers(helperService.getVDIRef().getVdiType()),
                callbacks: {
                    dataChannelMessage: dataChannelMessageCallback,
                    ready: readyCallback,
                    processOffer: processOfferCallback,
                    processAnswer: processAnswerCallback,
                    processICECandidate: processICECandidateCallback,
                    dataChannelClose: dataChannelCloseCallback,
                    disconnected: disconnectCallback
                }
            };
            if (sharerConnection && sharerConnection.close) {
                sharerConnection.close();
                sharerConnection = null;
            }
            sharerConnection = new annotationConnection(opts);

            sharerConnection.connectCreateAnswer(data);
        }

        function stopAnnotation() {
            logService.log('calling stopAnnotation ...');
            var viewerConnections = service.getViewerConnections();

            for (var id in viewerConnections) {
                var connection = viewerConnections[id];
                connection.close();
                delete viewerConnections[id];
            }

            if (helperService.isElectron()) {
                $window.preloadedApi.remote.ipcRenderer.sendAnnotatorStopWindow();
            }

            annotationSuspended = false;
            inActiveConnection = false;
            isInitiator = false;
            isScreenShareFeedPlayed = false;
        }

        function sendDirectDisconnectEvent() {
            var data = { disconnect: true, reason: 'node disconnected' };
            service.dataChannelSend(data);
        }

        function dataChannelSend(data) {
            if (!isInitiator && sharerConnection) {
                data.viewerAttendantId = attendeeService.getAttendantId();
                sharerConnection.sendDataChannelMessage(data);
            }
        }

        function setCursorColor(color) {
            var colorCode = color.replace('#', '');
            let rule = `cursor: url("data:image/svg+xml,%3Csvg width='25' height='24' viewBox='0 0 25 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M20.1272 7.5962C20.713 7.01041 20.713 6.06066 20.1272 5.47488L18.713 4.06066C18.1272 3.47488 17.1775 3.47488 16.5917 4.06066L15.531 5.12132L19.0666 8.65686L20.1272 7.5962Z' fill='%23${colorCode}'/%3E%3Cpath d='M17.6523 10.0711L14.1168 6.53554L4.15234 16.5L3.65234 20.5L7.65234 20L17.6523 10.0711Z' fill='%23${colorCode}'/%3E%3C/svg%3E%0A") 0 30, crosshair;`;
            cursorStyle.textContent = `#annotation-canvas { ${rule} }`;
        }

        //mapping events
        //conference
        function attachListeners() {
            if (!listenersAttached) {
                if (sharerConnection && sharerConnection.getIsInActiveConnection()) {
                    if (!attendeeService.getIsSfuEnabled()) {
                        startCanvasSizeMonitoring();
                        $('#hdScreenShareFeed').addClass('saPointer');
                    } else {
                        $window.$('.remote.screen.primary').addClass('annotation');
                    }
                    $window.addEventListener('mouseup', handleMouseUp);
                    $window.addEventListener('mousedown', handleMouseDown);
                    $window.addEventListener('mousemove', handleMouseMove);
                    $window.addEventListener('contextmenu', handleMouseUp);
                    $window.addEventListener('blur', handleMouseUp);
                    $window.addEventListener('beforeunload', handleMouseUp);
                    createDrawingCanvasForAnnotation();
                    listenersAttached = true;
                }
            }
        }

        function removeListeners(param) {
            destroyDrawingCanvasForAnnotation();
            if (!param || (!param.shouldNotStopCanvasMonitoring && !attendeeService.getIsSfuEnabled())) {
                stopCanvasSizeMonitoring();
                $('#hdScreenShareFeed').removeClass('saPointer');
            }
            $window.removeEventListener('mouseup', handleMouseUp);
            $window.removeEventListener('mousedown', handleMouseDown);
            $window.removeEventListener('mousemove', handleMouseMove);
            $window.removeEventListener('contextmenu', handleMouseUp);
            $window.removeEventListener('blur', handleMouseUp);
            $window.removeEventListener('beforeunload', handleMouseUp);
            listenersAttached = false;
            if (attendeeService.getIsSfuEnabled()) {
                $window.$('.remote.screen.primary').removeClass('annotation');
            }
            handleMouseUp({ clientX: 0, clientY: 0 });
            if (helperService.getVDIRef().getVdiType() === executionEnvironmentEnum.Citrix) {
                const sharedScreenStreamElement = window.document.querySelector('.remote.screen.primary');
                sharedScreenStreamElement.removeEventListener('mousemove', service.handleMouseEnterEventOnCanvas);
                if (document.getElementById('citrix-cursor-style')) {
                    document.head.removeChild(citrixCursorStyle);
                }
            }
        }

        function handleMouseDown(ev) {
            var data = getMouseData(ev);
            data.mouseEvent = true;
            data.mouseDown = true;

            if (mouseEventOnAnnotationPen(ev)) {
                return;
            }

            if (ev.target == $window.document.getElementById('hdScreenShareFeed')) {
                annotationOccured = true;
            }

            service.dataChannelSend(data);
            if (annotator) {
                annotator.addNewLayer();
            }
        }

        function handleMouseUp(ev) {
            var data = getMouseData(ev);
            data.mouseEvent = true;
            data.mouseUp = true;

            if (mouseEventOnAnnotationPen(ev)) {
                return;
            }

            if (annotationOccured) {
                analyticsWrapperService.eventTrack('Meeting - Annotation - started annotating', {
                    category: 'Annotation',
                    attendee: attendeeService.getEmail()
                });
                annotationOccured = false;
            }

            service.dataChannelSend(data);
            if (annotator) {
                annotator.closePath();
            }
        }

        function handleMouseMove(ev) {
            if (ev.buttons === 0) {
                //ev.buttons = 0 implies no button was clicked/held
                return;
            }

            if (isDraggingEnableButton) {
                return;
            }

            if (ev.target == $window.document.getElementById('hdScreenShareFeed')) {
                annotationOccured = true;
            }

            var data = getMouseData(ev);

            data.mouseEvent = true;
            data.mouseMove = true;
            data.mouseUp = false;
            service.dataChannelSend(data);
            if (annotator) {
                annotator.addCoordinate(data.clientX, data.clientY);
            }
        }

        function handleMouseClick(ev) {
            var data = getMouseData(ev);
            data.mouseEvent = true;
            data.mouseClick = true;

            service.dataChannelSend(data);
        }

        function handleMouseDoubleClick(ev) {
            var data = getMouseData(ev);
            data.mouseEvent = true;
            data.mouseDoubleClick = true;
            data.button = ev.button;

            service.dataChannelSend(data);
        }

        function getMouseData(ev) {
            var video = null;
            var data = {};
            data.clientX = ev.clientX;
            data.clientY = ev.clientY;

            if (attendeeService.getIsSfuEnabled()) {
                video = $window.document.querySelector('.remote.screen.primary');
                var canvas = $window.document.querySelector('.remote.screen.primary > canvas');
                if (video && canvas) {
                    videoSize = video.getBoundingClientRect();
                    data.clientX = data.clientX - videoSize.left - canvas.offsetLeft;
                    data.clientY = data.clientY - videoSize.top - canvas.offsetTop;
                    data.canvasWidth = canvas.offsetWidth;
                    data.canvasHeight = canvas.offsetHeight;
                }
            } else {
                video = $window.document.querySelector('#hdScreenShareFeed');
                if (video) {
                    videoSize = video.getBoundingClientRect();
                    data.clientX = data.clientX - videoSize.left;
                    data.clientY = data.clientY - videoSize.top;
                    data.canvasWidth = videoSize.width;
                    data.canvasHeight = videoSize.height;
                }
            }

            return data;
        }

        function getIsActive() {
            if (sharerConnection && sharerConnection.getIsInActiveConnection() && !service.getIsSuspended()) {
                return true;
            }
            return false;
        }

        function startCanvasSizeMonitoring() {
            logService.log('calling startCanvasSizeMonitoring ...');
            var videoFeed = $window.angular.element('#hdScreenShareFeed');
            var canvasArea = $window.angular.element('#canvas-touch-handler');
            var annotationCanvas = $window.angular.element('#annotation-canvas');

            canvasMonitoringService.startCanvasMonitor(contentService, videoFeed, canvasArea, annotationCanvas);
        }

        function stopCanvasSizeMonitoring() {
            logService.log('calling stopCanvasSizeMonitoring ...');
            canvasMonitoringService.stopCanvasMonitor();
        }

        function createDrawingCanvasForAnnotation() {
            annotator = new $window.Annotator(attendeeService.getAttendantId(), '', annotatorColor, true);

            drawingCollector = $window.setInterval(function () {
                var annotatorLayers = annotator.getLayers();
                for (var layerId in annotatorLayers) {
                    var layer = annotatorLayers[layerId];
                    if (layer.expired) {
                        if (layer.layer.opacity > 0) {
                            layer.layer.opacity -= 0.1;
                            if (layer.layer.opacity <= 0) {
                                layer.layer.remove();
                                delete annotatorLayers[layerId];
                            }
                        }
                    }
                }
            }, 100);
        }

        function destroyDrawingCanvasForAnnotation() {
            if (drawingCollector) {
                $window.clearInterval(drawingCollector);
            }
            service.clearCanvas();
        }

        function clearCanvas() {
            if ($window.paper && $window.paper.project) {
                $window.paper.project.clear();
            }
        }
        function onHDScreenShareConfCallConnected() {
            if (!service.getIsInitiator()) {
                $window.$('.annotation-enabler-button').draggable({
                    containment: 'window',
                    start: function (event, ui) {
                        hideAnnotationTooltip();
                        isDraggingEnableButton = true;
                    },
                    drag: hideAnnotationTooltip,
                    stop: function (event, ui) {
                        // event.toElement is the element that was responsible
                        // for triggering this event. The handle, in case of a draggable.
                        service.recalculatePenButtonPosition();
                        setTimeout(function () {
                            isDraggingEnableButton = false;
                        }, 1);
                    }
                });
            }
        }

        function hideAnnotationTooltip() {
            let tooltipId = $window.$('#annotation-button').attr('aria-describedby');
            $window.$('#' + tooltipId).hide();
        }

        function onMeetingStateV2Updated(e, options) {
            logService.log('annotationService - Meeting State V2 Updated: ' + options.state);
            if (options.state === 'ending') {
                if (!service.getIsInitiator()) {
                    service.setIsInSession(false);
                    if (requestTimeOutTimer) {
                        $timeout.cancel(requestTimeOutTimer);
                    }
                }
            }
        }

        function digest() {
            if (!$rootScope.$$phase) {
                $rootScope.$digest();
            }
        }

        function isPenDragEnabled() {
            return isDraggingEnableButton;
        }

        function setAnnotationPenDraggable() {
            onHDScreenShareConfCallConnected();
        }

        function mouseEventOnAnnotationPen(ev) {
            return $(ev.target).parents('.annotation-enabler-button').length > 0;
        }

        function isScreenShareFeedPlaying() {
            if (isScreenShareFeedPlayed) {
                return true;
            } else if (helperService.getVDIRef().getVdiType() === executionEnvironmentEnum.Citrix) {
                isScreenShareFeedPlayed =
                    $window.$('.remote.screen.primary')?.attr('playing') === 'true' &&
                    $window.$('.remote.screen.primary > video').get(0)?.remoteVideoElement?.isLoaded;
                return isScreenShareFeedPlayed;
            } else if (helperService.getVDIRef().getVdiType() === executionEnvironmentEnum.VMware) {
                isScreenShareFeedPlayed =
                    $window.$('.remote.screen.primary')?.attr('playing') === 'true' &&
                    $window.$('.remote.screen.primary > video').get(0)?.videoWidth > 0;
                return isScreenShareFeedPlayed;
            } else {
                isScreenShareFeedPlayed =
                    $window.$('.remote.screen.primary')?.attr('playing') === 'true' &&
                    $window.$('.remote.screen.primary > video').get(0)?.readyState === 4;
                return isScreenShareFeedPlayed;
            }
        }

        function showAnnotationButtonOnTopVDI() {
            if (!helperService.getVDIRef().showContentsOnTopOfVideo) {
                const annotationButton = $window.$('#annotation-button')[0];
                if (annotationButton) {
                    const newBounds = annotationButton.getBoundingClientRect();
                    if (annotationButtonBounds === null || !helperService.isEqual(annotationButtonBounds, newBounds)) {
                        if (
                            annotationButtonBounds !== null &&
                            !helperService.isEqual(annotationButtonBounds, newBounds)
                        ) {
                            helperService.getVDIRef().removeClipRect(annotationButtonBounds);
                        }
                        helperService.getVDIRef().addClipRect(newBounds);
                        vdiService.setAnnotationButtonBounds(newBounds);
                        annotationButtonBounds = newBounds;
                    }
                    if (!tooltipListenerAttachedForVDI) {
                        attachTooltipListenerForVDI();
                    }
                }
            }
        }

        function attachTooltipListenerForVDI() {
            const annotationButton = $window.$('#annotation-button');

            annotationButton.on('shown.bs.tooltip', function () {
                showAnnotationButtonTooltipOnTopVDI();
            });
            annotationButton.on('hidden.bs.tooltip', function () {
                if (annotationButtonTooltipBounds !== null) {
                    helperService.getVDIRef().removeClipRect(annotationButtonTooltipBounds);
                    annotationButtonTooltipBounds = null;
                }
            });
            tooltipListenerAttachedForVDI = true;
        }

        function showAnnotationButtonTooltipOnTopVDI() {
            if (!helperService.getVDIRef().showContentsOnTopOfVideo) {
                const tooltipId = $window.$('#annotation-button').attr('aria-describedby');
                const annotationButtonTooltip = $window.$('#' + tooltipId).get(0);
                if (annotationButtonTooltip) {
                    var newBounds = annotationButtonTooltip.getBoundingClientRect();
                    if (annotationButtonTooltipBounds !== null) {
                        helperService.getVDIRef().removeClipRect(annotationButtonTooltipBounds);
                    }
                    helperService.getVDIRef().addClipRect(newBounds);
                    annotationButtonTooltipBounds = newBounds;
                }
            }
        }

        function cleanupAnnotationUiForVDI() {
            if (annotationButtonBounds !== null) {
                helperService.getVDIRef().removeClipRect(annotationButtonBounds);
                annotationButtonBounds = null;
                vdiService.setAnnotationButtonBounds(annotationButtonBounds);
            }
            if (annotationButtonTooltipBounds !== null) {
                helperService.getVDIRef().removeClipRect(annotationButtonTooltipBounds);
                annotationButtonTooltipBounds = null;
            }
        }

        function formatIceServersForVDI(iceServers) {
            let vdiIceServers = [];
            for (var i = 0; i < iceServers.length; i++) {
                vdiIceServers[i] = {};
                vdiIceServers[i].username = iceServers[i].username ? iceServers[i].username : '';
                vdiIceServers[i].urls = [iceServers[i].urls];
                vdiIceServers[i].credential = iceServers[i].credential ? iceServers[i].credential : '';
            }
            return vdiIceServers;
        }

        function prepareIceServers(executionEnvironment) {
            if (executionEnvironment === executionEnvironmentEnum.Citrix) {
                return service.formatIceServersForVDI(vertoService.getIceServers());
            }
            return vertoService.getIceServers();
        }

        function getShouldRestartAnnotationAfterSocketReconnect() {
            return restartAnnotationAfterSocketReconnect;
        }

        function setShouldRestartAnnotationAfterSocketReconnect(restartAnnotation) {
            restartAnnotationAfterSocketReconnect = restartAnnotation;
        }

        function attachAnnotationListenersOnCitrix() {
            if (helperService.getVDIRef().getVdiType() === executionEnvironmentEnum.Citrix) {
                logger.log('attachAnnotationListenersOnCitrix', 'Citrix - attach mouse-enter event on canvas');
                service.setCitrixCursorColor(annotatorColor);
                const sharedScreenStreamElement = window.document.querySelector('.remote.screen.primary');
                sharedScreenStreamElement.addEventListener('mousemove', service.handleMouseEnterEventOnCanvas);
            }
        }

        function setCitrixCursorColor(color) {
            var colorCode = color.replace('#', '');
            const rule = `cursor: url("data:image/svg+xml,%3Csvg width='25' height='24' viewBox='0 0 25 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M20.1272 7.5962C20.713 7.01041 20.713 6.06066 20.1272 5.47488L18.713 4.06066C18.1272 3.47488 17.1775 3.47488 16.5917 4.06066L15.531 5.12132L19.0666 8.65686L20.1272 7.5962Z' fill='%23${colorCode}'/%3E%3Cpath d='M17.6523 10.0711L14.1168 6.53554L4.15234 16.5L3.65234 20.5L7.65234 20L17.6523 10.0711Z' fill='%23${colorCode}'/%3E%3C/svg%3E%0A") 0 30, crosshair !important;`;
            citrixCursorStyle.textContent = `.remote.screen.primary { ${rule} }`;
        }

        function handleMouseEnterEventOnCanvas(ev) {
            if (helperService.isMouseEventInElement(ev, window.document.querySelector('#annotation-canvas'))) {
                if (!document.getElementById('citrix-cursor-style')) {
                    document.head.appendChild(citrixCursorStyle);
                }
            }
        }
    }
]);
